import React from 'react'

export default function MyLoading() {
  return (
    <div style={{zIndex:99, with:'100%', height:'100%', color:'red', fontSize:'18px'}}>
        Ачааллаж байна. Түр хүлээнэ үү</div>
  )
}
